export default __webpack_public_path__ + "static/media/Microphone.64ae5b1c.svg";